<template>
  <svg width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18.25" cy="18.47" r="17.5" fill="#fff" fill-opacity=".9"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.167 19.0044c0 3.6148-2.9173 6.5322-6.5 6.5322s-6.5-2.9174-6.5-6.5322c0-3.6148 2.9173-6.5322 6.5-6.5322.8673 0 1.6956.1709 2.453.4814l-.0072-1.2225 1.9815-.0116c-1.2895-.7913-2.8053-1.2473-4.4273-1.2473-4.6944 0-8.5 3.82-8.5 8.5322 0 4.7122 3.8056 8.5322 8.5 8.5322s8.5-3.82 8.5-8.5322c0-.1664-.0048-.3317-.0141-.4958l-2.0035.0118c.0117.1598.0176.3212.0176.484Z" fill="#5300BB"/>
    <path d="m24.3356 13.9922-5.3198.7983 3.5268-5.88885 1.793 5.09055Z" fill="#5300BB"/>
  </svg>
</template>
